import { ReactNode, useCallback, useEffect, useRef, useState } from "react";

interface MobilePreviewFrameProps {
  children: ReactNode;
}

//--> 실제 폰 화면 폭
const PHONE_WIDTH = 390;
//--> 아래 여백
const BOTTOM_RESERVE = 40;
const MIN_HEIGHT = 420;

//--> 폰 화면 미리보기 틀. 창 높이만큼 잡고, 내용이 길면 안에서 스크롤한다.
export default function MobilePreviewFrame({ children }: MobilePreviewFrameProps) {
  const boxRef = useRef<HTMLDivElement>(null);
  const [height, setHeight] = useState<number | undefined>(undefined);

  const fit = useCallback(() => {
    const box = boxRef.current;
    if (!box) return;
    const top = box.getBoundingClientRect().top;
    setHeight(Math.max(MIN_HEIGHT, window.innerHeight - top - BOTTOM_RESERVE));
  }, []);

  useEffect(() => {
    fit();
    window.addEventListener("resize", fit);
    return () => window.removeEventListener("resize", fit);
  }, [fit]);

  return (
    <div
      ref={boxRef}
      className="mx-auto overflow-y-auto overflow-x-hidden rounded-lg border bg-white"
      style={{ width: PHONE_WIDTH, maxWidth: "100%", height: height }}
    >
      {children}
    </div>
  );
}
